module.exports = __webpack_public_path__ + "media/12_36.e34dc9e1.wav";